import {RouteConfig} from 'vue-router'
import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'
import UsersList from '@/pages/Users/UsersList.vue'
import UserCreate from '@/pages/Users/UserCreate.vue'
import UserPage from '@/pages/Users/UserPage.vue'
import UserEdit from '@/pages/Users/UserEdit.vue'
import {USER_ROLE_ADMIN} from '@/constants'

// @ts-ignore
import messages from '@/lang/index';

const users: RouteConfig = {
  path: '/users',
  name: 'users',
  meta: {
    pageName: messages.employees.page_name
  },
  component: DashboardLayout,
  redirect: '/users/list',
  children: [
    {
      path: 'list',
      name: 'UsersList',
      meta: {
        pageName: messages.employees.list
      },
      component: UsersList
    },
    {
      path: 'list/page/:page',
      name: 'UsersPage',
      meta: {
        pageName: messages.employees.list
      },
      component: UsersList
    },
    {
      path: 'create',
      name: 'userCreate',
      meta: {
        pageName: messages.employees.create,
        access: USER_ROLE_ADMIN
      },
      component: UserCreate
    },
    {
      path: '/users/:id',
      name: 'user',
      meta: {
        pageName: messages.employees.info
      },
      component: UserPage,
      props: true
    },
    {
      path: 'edit/:id',
      name: 'userEdit',
      meta: {
        pageName: messages.employees.edit,
        access: USER_ROLE_ADMIN
      },
      component: UserEdit,
      props: true
    }
  ]
}
export default users;